let instanceFactory = null;

export function setInstanceFactory(factory) {
  instanceFactory = factory;
}

// Download a blob as a file
export function downloadBlob(blob, filename) {
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
}

export async function exportModel(initialInstance, mainFile, vars, format) {
  const statusText = document.getElementById("status-text");
  statusText.textContent = `Exporting ${format.toUpperCase()}...`;

  const newInst = await instanceFactory();
  const outFile = "export." + format;

  newInst.FS.writeFile("/current.scad", initialInstance.FS.readFile("/" + mainFile));

  const args = ["/current.scad", "-o", outFile, "--export-format=" + format];

  for (const [name, value] of Object.entries(vars)) {
    args.push("-D" + name + "=" + JSON.stringify(value));
  }

  const exitCode = newInst.callMain(args);
  if (exitCode !== 0) {
    throw new Error(`OpenSCAD export failed with code ${exitCode}`);
  }

  const data = newInst.FS.readFile("/" + outFile);
  const blob = new Blob([data], { type: getMimeType(format) });
  downloadBlob(blob, `model.${format}`);

  statusText.textContent = `${format.toUpperCase()} exported.`;
}

function getMimeType(format) {
  const types = {
    stl: "application/sla",
    "3mf": "application/3mf",
    glb: "model/gltf-binary",
    off: "text/plain",
  };
  return types[format] || "application/octet-stream";
}